import { formatPhoneDisplay } from "../utils/time";

/**
 * The `phone` person property, in one format whichever source it came from.
 *
 * A phone-first homeowner has no email, so without this their PostHog person shows only the raw
 * Firebase UID and support cannot find them. Two sources feed it -- the Firebase user
 * (`+6581234567`) right after OTP, and the DB profile (`81234567`) on every later page load --
 * so both are normalised to `+65 8123 4567`, otherwise each would overwrite the other.
 *
 * Returns undefined for a missing or malformed number so the property is left alone rather than
 * set to "-".
 */
export function toPersonPhone(phone?: string | null): string | undefined {
  const formatted = formatPhoneDisplay(phone);
  return formatted === "-" ? undefined : formatted;
}
